// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37JKl","top":"styles_top__jxr0Q"};